import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'shrinkCode'})
export class ShrinkCodePipe implements PipeTransform {
   transform(value: any) {
       if (value.length >= 10) {
        return value.substr(0, 5) + '...' + value.substr(value.length - 5, value.length);
       }

       return value;
   }
}
